import { BigNumber } from 'ethers';
import { zeroAddress } from 'viem';
import { getCallDataForUserop } from '../lib/getCallDataForUserOp';
import { needsUpgrade } from '../utils/needsUpgrade';
import { subtractGasFromBalance } from '../lib/permissionless/middleware/substractGasFromValue';
import { prepareUnsponsoredOp } from '../utils/prepareUnsponsoredOp';
export async function transferEth(params) {
    const { transferData, signer, smartAccount, newAccountImplementationType } = params;
    const { recipient, value } = transferData;
    const aaAddress = smartAccount.address;
    if (!aaAddress) {
        throw new Error('Failed to get AA address');
    }
    const account = smartAccount.client.account;
    if (!account) {
        throw new Error('smart account undefined');
    }
    console.log('[UserOperations] sendTransferEthOp', {
        toAddress: recipient,
        callData: '0x',
        functionHashForPaymasterProxy: 'transferEth',
        spaceId: undefined,
        value,
    });
    const valueBigInt = BigNumber.from(value).toBigInt();
    // prepare the user op
    const preparedUserOp = await prepareUnsponsoredOp({
        smartAccount: smartAccount,
        callData: await getCallDataForUserop({
            toAddress: recipient,
            callData: '0x',
            value: valueBigInt,
            smartAccount,
            signer,
            needsUpgrade: needsUpgrade(newAccountImplementationType, smartAccount.type),
            functionHash: 'transferEth',
        }),
    });
    if (!smartAccount.client.chain?.id) {
        throw new Error('Chain ID is required');
    }
    ////////////////////////////////////////////////////////////////////////////////
    // If user is transferring eth, potentially subtract gas from balance being sent
    ////////////////////////////////////////////////////////////////////////////////
    const newValue = await subtractGasFromBalance({
        chainId: smartAccount.client.chain?.id,
        gas: {
            preVerificationGas: preparedUserOp.preVerificationGas,
            callGasLimit: preparedUserOp.callGasLimit,
            maxFeePerGas: preparedUserOp.maxFeePerGas,
            verificationGasLimit: preparedUserOp.verificationGasLimit,
        },
        callData: preparedUserOp.callData,
        client: smartAccount.publicRpcClient,
        value: valueBigInt,
        functionHash: 'transferEth',
        smartAccount: account,
    });
    return smartAccount.sendUserOp({
        toAddress: recipient,
        callData: '0x',
        functionHashForPaymasterProxy: 'transferEth',
        signer,
        spaceId: undefined,
        // send the new value so the user op is prepared again with the new value
        value: newValue,
    });
}
export async function burnZeroEth(params) {
    const { signer, smartAccount } = params;
    const aaAddress = smartAccount.address;
    if (!aaAddress) {
        throw new Error('Failed to get AA address');
    }
    return smartAccount.sendUserOp({
        toAddress: zeroAddress,
        callData: '0x',
        functionHashForPaymasterProxy: 'burnZeroEth',
        signer,
        spaceId: undefined,
        value: 0n,
    });
}
